import React, { useEffect } from "react";
import Banner from "../components/whyus/Banner";
import Control from "../components/whyus/Control";
import Confidence from "../components/whyus/Confidence";
import Support from "../components/whyus/Support";
import Mindset from "../components/whyus/Mindset";
import MissionVision from "../components/whyus/MissionVision";
import CTASection from "../components/whyus/CTASection";

function WhyUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden">
      <Banner />
      <Control />
      <Confidence />
      <Support />
      <Mindset />
      <MissionVision />
      <CTASection />
    </div>
  );
}

export default WhyUs;
